export default "__VITE_ASSET__BL5LvHf3__"